module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popularize"
  }, [_c('img', {
    staticClass: "top-banner",
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/others/banner2.jpg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "separate-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "best-work-list"
  }, [_c('div', {
    staticClass: "work-wrapper"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ximalaya.com/1266964/album/4756811/"
    }
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day2/摸金天师.jpg")
    }
  })]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "separate-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "work-wrapper"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ximalaya.com/4932085/album/3160816/"
    }
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day2/超品相师.jpg")
    }
  })]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "separate-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "work-wrapper"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ximalaya.com/2979487/album/2684111/"
    }
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day2/卑鄙的圣人：曹操.jpg")
    }
  })]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "separate-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "top-work-wrapper"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("- 这些作品都产生于这里 -")]), _vm._v(" "), _c('div', {
    staticClass: "top-work-list"
  }, [_c('div', {
    staticClass: "work-wrapper"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ximalaya.com/16945541/album/4615999/"
    }
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day2/斗破苍穹.jpg")
    }
  })]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "work-wrapper"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ximalaya.com/1199493/album/294834/"
    }
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day2/从你的全世界路过.gif")
    }
  })]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "work-wrapper"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ximalaya.com/1884830/album/350700/"
    }
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day2/刘心武揭秘红楼梦.jpg")
    }
  })]), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _c('div', {
    staticClass: "work-wrapper"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ximalaya.com/1266964/album/9877679/"
    }
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day2/狠人狠事.jpg")
    }
  })]), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('div', {
    staticClass: "work-wrapper"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ximalaya.com/1266964/album/356310/"
    }
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day2/藏地密码.jpg")
    }
  })]), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _c('div', {
    staticClass: "work-wrapper"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ximalaya.com/13511549/album/8791642/"
    }
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day2/活着.jpg")
    }
  })]), _vm._v(" "), _vm._m(9)])])]), _vm._v(" "), _c('div', {
    staticClass: "separate-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "more-wrapper"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("- 了解更多 -")]), _vm._v(" "), _c('div', {
    staticClass: "links-wrapper"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'idols'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/others/大神云集@2x.png")
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'workLib'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/others/海量作品@2x.png")
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'benefits'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/others/福利体系@2x.png")
    }
  })])], 1)]), _vm._v(" "), _c('router-link', {
    staticClass: "btn-join-bottom",
    attrs: {
      "to": {
        name: 'anchorIndex'
      }
    }
  }, [_vm._v("立即加入")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn-join-fixed",
    attrs: {
      "to": {
        name: 'anchorIndex'
      }
    }
  }, [_vm._v("立即加入")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-context"
  }, [_c('p', [_vm._v("也许你还不知道，《摸金天师》《超品相师》《卑鄙的圣人：曹操》……")]), _vm._v(" "), _c('p', [_vm._v("这些被亿万听众熟知的经典有声作品，都来自作品有声化平台")]), _vm._v(" "), _c('p', [_vm._v("加入我们，拥有你的专属团队，迎接你的万千粉丝")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "work-content"
  }, [_c('div', {
    staticClass: "work-top"
  }, [_c('a', {
    staticClass: "work-name",
    attrs: {
      "href": "http://www.ximalaya.com/1266964/album/4756811/"
    }
  }, [_vm._v("《摸金天师》")]), _vm._v(" "), _c('span', {
    staticClass: "listen-count"
  }, [_c('strong', [_vm._v("123000万")]), _vm._v("次播放")])]), _vm._v(" "), _c('a', {
    staticClass: "anchor-name",
    attrs: {
      "href": "http://www.ximalaya.com/zhubo/1266964/"
    }
  }, [_vm._v("主播：有声的紫襟")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("秦岭大山里的墓葬群，西北戈壁中的无人区，浩瀚深海下的失落遗迹，雪域高原上的死亡禁区……"), _c('br'), _vm._v("或许有一天，当你因为贪婪而拿了不该拿的东西时，你就会发现睡觉时有东西站你旁边，告诉你，天黑了，一起来玩玩吧。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "work-content"
  }, [_c('div', {
    staticClass: "work-top"
  }, [_c('a', {
    staticClass: "work-name",
    attrs: {
      "href": "http://www.ximalaya.com/4932085/album/3160816/"
    }
  }, [_vm._v("《超品相师》")]), _vm._v(" "), _c('span', {
    staticClass: "listen-count"
  }, [_c('strong', [_vm._v("82000万")]), _vm._v("次播放")])]), _vm._v(" "), _c('a', {
    staticClass: "anchor-name",
    attrs: {
      "href": "http://www.ximalaya.com/zhubo/4932085/"
    }
  }, [_vm._v("主播：丸子")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("相师分九品，一品一重天，二品是入门，三品算是登堂，四品之后才能真正的称为相师。风水有境界、明理、养气、修身、问道。"), _c('br'), _vm._v("二十一世纪的一位普通青年秦宇偶获诸葛亮生前的玄学传承，从此混迹都市，游走于高官权贵之间，豪门千金，世家小姐身侧……")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "work-content"
  }, [_c('div', {
    staticClass: "work-top"
  }, [_c('a', {
    staticClass: "work-name",
    attrs: {
      "href": "http://www.ximalaya.com/2979487/album/2684111/"
    }
  }, [_vm._v("《卑鄙的圣人：曹操》")]), _vm._v(" "), _c('span', {
    staticClass: "listen-count"
  }, [_c('strong', [_vm._v("7500万")]), _vm._v("次播放")])]), _vm._v(" "), _c('a', {
    staticClass: "anchor-name",
    attrs: {
      "href": "http://www.ximalaya.com/zhubo/2979487/"
    }
  }, [_vm._v("主播：文涛学员")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("一件件讲透，曹操收拾三国群雄的卑鄙、奸诈、狠毒计谋；一页页浸透，曹操体恤天下众生的柔情、仁义、圣人情怀。"), _c('br'), _vm._v("曹操的计谋，奸诈程度往往将对手整得头昏脑涨、找不着北，卑鄙程度也屡屡突破道德底线，但他却是一个心怀天下、体恤众生的圣人……")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "work-right"
  }, [_c('a', {
    staticClass: "work-name",
    attrs: {
      "href": "http://www.ximalaya.com/16945541/album/4615999/"
    }
  }, [_vm._v("斗破苍穹")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("超级IP改编有声剧，玄幻网文至尊经典小说！"), _c('br'), _vm._v("网络总点击20亿次！各大网络文学榜单NO.1大满贯之作！")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "work-right"
  }, [_c('a', {
    staticClass: "work-name",
    attrs: {
      "href": "http://www.ximalaya.com/1199493/album/294834/"
    }
  }, [_vm._v("从你的全世界路过")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("喜马拉雅出品，微博最会讲故事的人——张嘉佳，睡前故事集《从你的全世界路过》唯一指定官方有声系列")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "work-right"
  }, [_c('a', {
    staticClass: "work-name",
    attrs: {
      "href": "http://www.ximalaya.com/1884830/album/350700/"
    }
  }, [_vm._v("刘心武揭秘红楼梦")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("著名作家刘心武在央视所作的红学系列讲座同名书籍，解读了出书中数十位人物命运轨迹，由此提出诸多新的高级精神内涵。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "work-right"
  }, [_c('a', {
    staticClass: "work-name",
    attrs: {
      "href": "http://www.ximalaya.com/1266964/album/9877679/"
    }
  }, [_vm._v("狠人狠事")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("有声的紫襟。喜马拉雅FM超人气王牌主播倾情演绎，声音磁性，演播方式多变，讲述了真正的黑道，真正的江湖！")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "work-right"
  }, [_c('a', {
    staticClass: "work-name",
    attrs: {
      "href": "http://www.ximalaya.com/1266964/album/356310/"
    }
  }, [_vm._v("藏地密码")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("以120万字的宏大架构，讲述了以西藏为背景的一个全球大探险故事，其中涉及到西藏千年秘史、藏传佛教历史遗案，以及世界上众多著名文化遗迹。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "work-right"
  }, [_c('a', {
    staticClass: "work-name",
    attrs: {
      "href": "http://www.ximalaya.com/13511549/album/8791642/"
    }
  }, [_vm._v("活着")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("张艺谋电影《活着》原著小说，孟京辉话剧《活着》原著小说，电视剧《福贵》原著小说"), _c('br'), _vm._v("即便生活中有苟且、痛苦与迷茫，也请欣然坚定地活着")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dfd74780!./~/vue-loader/lib/selector.js?type=template&index=0!./views/popularize/Classic.vue
// module id = 1107
// module chunks = 0